import styled from 'styled-components';
import Box from '@material-ui/core/Box';

export const StyledBox = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
`;
